// extracted by mini-css-extract-plugin
export default {"container":"RegisterScreen_container__RhRTU","content":"RegisterScreen_content__YTkur","action":"RegisterScreen_action__0EiOo","inlineLink":"RegisterScreen_inlineLink__ij2zr"};